import * as Sentry from '@sentry/react'
import { I18nextProvider } from 'react-i18next'
import { BrowserRouter as Router } from 'react-router-dom'

import { ClientContextController } from '@percent/product-nomination-form/context/client/clientContextController/ClientContextController'
import { FormContextController } from '@percent/product-nomination-form/context/form/FormContextController/FormContextController'
import { i18n } from '@percent/product-nomination-form/i18n/config'

import { PropsWithChildren } from 'react'
import { PartnerConfigContextController } from '../context/partnerConfig/PartnerConfigContextController/PartnerConfigContextController'
import { ErrorFallback } from './ErrorFallback'
import { ThemeProvider } from './ThemeProvider/ThemeProvider'

export const AppProviders = ({ children }: PropsWithChildren) => (
  <PartnerConfigContextController>
    <ThemeProvider>
      <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
        <I18nextProvider i18n={i18n}>
          <FormContextController>
            <Router>
              <ClientContextController>{children}</ClientContextController>
            </Router>
          </FormContextController>
        </I18nextProvider>
      </Sentry.ErrorBoundary>
    </ThemeProvider>
  </PartnerConfigContextController>
)
